import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "@mui/material/Button";

const useStyles = makeStyles((theme) => ({
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "2%",
    width: "96%",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "2%",
    width: "96%",
  },
}));

export default function CreateButton(props) {
  const { buttonDisabled, handleSubmit, title } = props;

  const classes = useStyles();

  return (
    <Button
      disabled={buttonDisabled}
      className={
        buttonDisabled ? classes.submitButtonDisabled : classes.submitButton
      }
      onClick={() => {
        handleSubmit();
      }}
    >
      {title}
    </Button>
  );
}

CreateButton.defaultProps = {
  title: "Créer"
}

CreateButton.propTypes = {
  inputTitle: PropTypes.any,
  title: PropTypes.string,
};
